import { render } from "dom-serializer";
import { type AnyNode, isText } from "domhandler";
import { parseDocument } from "htmlparser2";
import { DomUtils } from "htmlparser2";

function replaceTextContent(node: AnyNode, text: string): void {
	if (isText(node)) {
		node.data = text;
		return;
	}
	if ("children" in node) {
		for (const child of node.children) {
			const childText = DomUtils.getText(child);
			if (text.startsWith(childText)) {
				text = text.slice(childText.length);
			} else {
				replaceTextContent(child, text);
				break;
			}
		}
	}
}

export function textLengthLimit(perex: string, limit = 750): string {
	const document = parseDocument(perex);
	const textContent = DomUtils.getText(document);

	if (textContent.length <= limit) {
		return perex;
	}

	const words = textContent.split(/\s+/u);
	let result = "";
	let currentLength = 0;

	for (const word of words) {
		if (currentLength + word.length <= limit) {
			result += `${word} `;
			currentLength += word.length + 1;
		} else {
			break;
		}
	}

	const truncatedText = `${result.trim()}…`;

	replaceTextContent(document, truncatedText);

	return render(document);
}
